// Developer: Ankit Gupta
/**
 * Unified auth hook that works with both Keycloak and dev-mode providers.
 */
import { useAuth as useKeycloakAuth } from './AuthProvider';
import { useDevAuth } from './DevAuthProvider';
import type { AuthContextValue } from './AuthProvider';

const isDevAuth = import.meta.env.VITE_DEV_AUTH === 'true';

export function useAuth(): AuthContextValue {
  if (isDevAuth) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useDevAuth();
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useKeycloakAuth();
}
